/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import Breadcrumb from "../../../../component/breadcrumb";
import ManageCustomersHierarchy from "../../manageCustomers/manageCustomersHierarchy";
import { withTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import Button from "../../../../component/button";
import { UsersIcon } from "../../../../component/icons/icons";
import { withNavigation } from "../../../../helper/withNavigation";

// Manage order page class
class Billing extends Component {
  // Declare property values that belongs to the component
  state = {
    bread: [{ title: this.props.t("BILLING_ACCOUNTS"), url: "/billing" }],
    display: false,
    isMobile: false,
    showCustomerList: false,
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
    this.props.setCompDidMount();
    let search = new URLSearchParams(this.props.router.location.search);
    let orderId = search.get("orderId");
    let userId = search.get("userId");
    this.setState(
      {
        orderId: orderId,
        userId: userId,
      },
      () => {
        this.setState({ display: true });
      },
    );
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }
  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };

  toggleShowCustomerList = () => {
    this.setState((prevState) => ({
      showCustomerList: !prevState.showCustomerList,
    }));
  };

  // Render order view
  render() {
    const { t } = this.props;
    const { isMobile, showCustomerList } = this.state;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              {isMobile && (
                <Grid
                  item
                  style={{ textAlign: "right" }}
                  size={{
                    xs: 12,
                  }}
                >
                  <Button
                    className="buttonSecondary"
                    onClick={this.toggleShowCustomerList}
                  >
                    <span
                      style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                    >
                      <UsersIcon />
                    </span>
                    {t("SHOW_CUSTOMER_LIST")}
                  </Button>
                </Grid>
              )}
              {/* <Grid item xs={6} align={'right'}>
                                <Button
                                    onClick={
                                        () => {
                                            this.hierarchyRef.showAddAdjustment();
                                        }
                                    } >
                                        <span style={{marginRight: '.25rem', verticalAlign: 'middle'}}>
                                        <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z" fill="currentColor"/>
                                        </svg>
                                        </span>
                                    {this.props.t('NEW_SUBSCRIPTION_ADJUSTMENT')}
                                </Button>
                            </Grid> */}
            </Grid>
          </div>
        </div>
        <main>
          {this.state.display && (
            <ManageCustomersHierarchy
              screen="billing"
              orderId={this.state.orderId}
              userId={this.state.userId}
              onRef={(ref) => (this.hierarchyRef = ref)}
              isMobile={isMobile}
              showCustomerList={showCustomerList}
              toggleShowCustomerList={this.toggleShowCustomerList}
            />
          )}
        </main>
      </div>
    );
  }
}

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  null,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Billing)));
